import React, { useRef, useState } from 'react';
import useIntersectionObserver from './hooks/useIntersectionObserver';
import './style.css';

const Stats = () => {
    const sectionRef = useRef(null);
    const [contentLoaded, setContentLoaded] = useState(false);

    const handleIntersection = () => {
        setContentLoaded(true);
    };

    const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

    return (
        <div ref={sectionRef} className={`loading-container${contentLoaded ? '' : ' loading-spinner-container'}`}>
            {contentLoaded ? (
                <section className={`stats${isVisible ? ' fade-in-observer' : ''}`} id="stats">
                    <ul className="stats-list">
                        <li>
                            <a className="stats-card" href="#">
                                <div className="card-icon">
                                    <ion-icon name="ribbon-outline"></ion-icon>
                                </div>
                                <h2 className="h2 card-title">
                                    12+
                                    <strong>
                                        Years of Experience
                                    </strong>
                                </h2>
                                <ion-icon name="chevron-forward-outline">
                                </ion-icon>
                            </a>
                        </li>
                        <li>
                            <a className="stats-card" href="#">
                                <div className="card-icon">
                                    <ion-icon name="albums-outline"></ion-icon>
                                </div>
                                <h2 className="h2 card-title">
                                    230+
                                    <strong>
                                        Completed Projects
                                    </strong>
                                </h2>
                                <ion-icon name="chevron-forward-outline">
                                </ion-icon>
                            </a>
                        </li>
                        <li>
                            <a className="stats-card" href="#">
                                <div className="card-icon">
                                    <ion-icon name="happy-outline"></ion-icon>
                                </div>
                                <h2 className="h2 card-title">
                                    95+
                                    <strong>
                                        Happy Clients
                                    </strong>
                                </h2>
                                <ion-icon name="chevron-forward-outline">
                                </ion-icon>
                            </a>
                        </li>
                    </ul>
                </section>
            ) : (
                <div className="observer_spinner"></div>
            )}
        </div>
    );
};

export default Stats;
